import React, { useState, useContext, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import CardHeader from '@mui/material/CardHeader';
import { CommonContext, MerchantContext } from '../../../context';
import commonApi from '../../../utils/api';
import { useLocation } from 'react-router-dom';
import { Autocomplete, Card, CardContent, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Input, MenuItem, Paper, Radio, RadioGroup, Select, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import axios from 'axios';
import { states } from '../../../utils/config';
import { scrollToTop } from '../../common/scrollToTop';

const BillingDetails = () => {
    const { user, setIsLoading, setOpenAlert, setAlertMessage, setSeverity, merchantDetails, rowData } = useContext(CommonContext)
    // const { rowData } = useContext(MerchantContext);
    let location = useLocation();
    const [formErrors, setFormErrors] = useState({});
    const [formDataTemp, setformDataTemp] = useState({
        merchant_id: '',
        email: '',
        contact_number: '',
        address: '',
        city: '',
        state_id: '',
        pincode: null,

    });
    useEffect(() => {
        if (merchantDetails?.merchantBilingDetails) {
            setformDataTemp(merchantDetails?.merchantBilingDetails)
        }
    }, [merchantDetails]);
    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setformDataTemp((prevData) => ({
            ...prevData,
            [name]: type === 'file' ? event.target.files[0] : value,
        }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const errors = {};
        if (!formDataTemp?.email) {
            errors.email = 'Email is required';
        }
        if (!formDataTemp.contact_number) {
            errors.contact_number = 'Contact Nmber is required';
        } else if (formDataTemp.contact_number.length < 10 || formDataTemp.contact_number.length > 10) {
            errors.contact_number = 'Enter valid Contact Number';
        }
        if (!formDataTemp?.address) {
            errors.address = 'Address is required';
        }
        if (!formDataTemp?.city) {
            errors.city = 'City is required';
        }
        if (!formDataTemp?.state_id) {
            errors.state_id = 'State is required';
        }
        if (!formDataTemp.pincode) {
            errors.pincode = 'Pincode is required';
        } else if (formDataTemp.pincode.length < 6 || formDataTemp.pincode.length > 6) {
            errors.pincode = 'Enter valid pincode';
        }
        if (user?.user_type === "Merchant") {
            formDataTemp.merchant_id = user?.id
        } else {
            formDataTemp.merchant_id = rowData?.id
        }
        setFormErrors(errors);
        if (Object.keys(errors).length === 0) {
            setIsLoading(true);
            commonApi.post('/merchant/billing-update', formDataTemp)
                .then((res) => {
                    setIsLoading(false);
                    setOpenAlert(true);
                    scrollToTop();
                    if (res?.data?.s === 0) {
                        setAlertMessage(res?.data?.msg);
                        setSeverity('error');
                    } else {
                        setAlertMessage(res?.data?.msg);
                        setSeverity('success');
                    }
                }).catch((err) => {
                    setOpenAlert(true);
                    setAlertMessage(err?.response?.data?.msg);
                    setSeverity('error')
                    setIsLoading(false);
                });
        }
    };
    return (
        <Box className="common-form-container">
            <form className="common-form-data" onSubmit={handleSubmit}>
                <Card className="form-section">
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item size={{ xs: 4, md: 4 }}>
                                <TextField
                                    label="Email"
                                    type='email'
                                    name="email"
                                    defaultValue={formDataTemp?.email}
                                    onChange={handleChange}
                                    fullWidth
                                    // margin="normal"
                                    size='small'
                                    error={!!formErrors.email}
                                    helperText={formErrors.email}
                                />
                            </Grid>
                            <Grid item size={{ xs: 4, md: 4 }}>
                                <TextField
                                    label="Contact Number"
                                    name="contact_number"
                                    defaultValue={formDataTemp.contact_number ?? ''}
                                    onChange={handleChange}
                                    fullWidth
                                    // margin="normal"
                                    size='small'
                                    error={!!formErrors.contact_number}
                                    helperText={formErrors.contact_number}
                                />
                            </Grid>
                            <Grid item size={{ xs: 4, md: 4 }}>
                                <TextField
                                    label="Address"
                                    name="address"
                                    defaultValue={formDataTemp.address ?? ''}
                                    onChange={handleChange}
                                    fullWidth
                                    // margin="normal"
                                    size='small'
                                    multiline
                                    minRows={1}
                                    error={!!formErrors.address}
                                    helperText={formErrors.address}
                                />
                            </Grid>
                            <Grid item size={{ xs: 4, md: 4 }}>
                                <TextField
                                    label="City"
                                    name="city"
                                    defaultValue={formDataTemp?.city}
                                    onChange={handleChange}
                                    fullWidth
                                    // margin="normal"
                                    size='small'
                                    error={!!formErrors.city}
                                    helperText={formErrors.city}
                                />
                            </Grid>
                            <Grid item size={{ xs: 4, md: 4 }}>
                                {/* <Select
                                    value={formDataTemp.state_id ?? ''}
                                    onChange={handleChange}
                                    name='state_id'
                                    displayEmpty
                                    sx={{ width: '100%', textAlign: 'left' }}
                                    inputProps={{ 'aria-label': 'Select State' }}
                                    className='select-input'
                                    error={!!formErrors.state_id}
                                    helperText={formErrors.state_id}
                                    fullWidth
                                >
                                    <MenuItem value="" disabled>
                                        Select State
                                    </MenuItem>
                                    {Object.entries(states).map(([key, value]) => (
                                        <MenuItem value={key} key={key}>{value}</MenuItem>
                                    ))}
                                </Select> */}
                                <Autocomplete
                                    options={Object.entries(states).map(([key, value]) => ({
                                        id: key,
                                        label: value,
                                    }))}
                                    getOptionLabel={(option) => option.label || ""}
                                    value={
                                        Object.entries(states)
                                            .map(([key, value]) => ({ id: key, label: value }))
                                            .find((item) => item.id === formDataTemp?.customer_state_id) || null
                                    }
                                    onChange={(event, newValue) => {
                                        handleChange({
                                            target: {
                                                name: "customer_state_id",
                                                value: newValue ? newValue.id : "",
                                            },
                                        });

                                        handleChange({
                                            target: {
                                                name: "customer_state",
                                                value: newValue ? newValue.label : "",
                                            },
                                        });
                                    }}
                                    // onBlur={() => {
                                    //     handleBlur({
                                    //         target: {
                                    //             name: "customer_state_id",
                                    //             value: formDataTemp?.customer_state_id,
                                    //         },
                                    //     });
                                    // }}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    sx={{
                                        "& .MuiInputBase-root": { paddingTop: "0", paddingBottom: "0" },
                                        margin: "0.5rem 0",
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Service State"
                                            variant="outlined"
                                            error={!!formErrors?.customer_state_id}
                                            helperText={formErrors?.customer_state_id}
                                            fullWidth
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item size={{ xs: 4, md: 4 }}>
                                <TextField
                                    label="Pincode"
                                    name="pincode"
                                    defaultValue={formDataTemp?.pincode}
                                    onChange={handleChange}
                                    fullWidth
                                    // margin="normal"
                                    size='small'
                                    error={!!formErrors.pincode}
                                    helperText={formErrors.pincode}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 12 }} sx={{ textAlign: 'right', marginTop: '1rem' }}>
                                <Button variant="contained" color="primary" type="submit">
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </form>
        </Box>
    );
};

export default BillingDetails;
